import Repository, {baseUrl} from './Repository';

// Function to create an inquiry
export async function createInquiry(token, params) {
    const endPoint = `/inquiry`;

    try {
        const response = await Repository.post(`${baseUrl}${endPoint}`, params, {
            headers: {
                'Content-Type': 'application/json;charset=utf-8',
                token: token,
            }
        });
        return response.data ? response.data : {code: 1000, message: response.statusText};
    } catch (error) {
        console.error(JSON.stringify(error));
        return {code: 1001, message: error.message};
    }
}

export async function getInquiriesForCompany(token) {
    const endPoint = `/inquiries/company`;

    try {
        const response = await Repository.get(`${baseUrl}${endPoint}`, {
            headers: {
                token: token,
            }
        });
        return response.data ? response.data : {code: 1000, message: response.statusText};
    } catch (error) {
        console.error(JSON.stringify(error));
        return {code: 1001, message: error.message};
    }
}

export async function getInquiries(token) {
    const endPoint = `/inquiries`;

    try {
        const response = await Repository.get(`${baseUrl}${endPoint}`, {
            headers: {
                token: token,
            }
        });
        return response.data ? response.data : {code: 1000, message: response.statusText};
    } catch (error) {
        console.error(JSON.stringify(error));
        return {code: 1001, message: error.message};
    }
}
